<template>
  <div class="g-content application-detail">
    <div class="g-content-filter">
      <div class="g-content-filter-main detail-header">
        <div class="page-subtitle">{{ $t('application_menu_detail') }}</div>
        <div class="flex">
          <a-button
            type="default"
            @click="$router.push({ name: 'ApplicationList' })"
            icon="double-left"
          >
            {{ $t('com_btn_back') }}
          </a-button>
          <a-button
            type="primary"
            class="btn-gap"
            @click="() => this.$router.push({ name: 'ApplicationUpdate' })"
          >
            {{ $t('com_btn_edit') }}
          </a-button>
          <a-button type="danger" class="danger-btn btn-gap" @click="remove">
            {{ $t('com_btn_delete') }}
          </a-button>
        </div>
      </div>
    </div>
    <div class="detail-content">
      <div class="left panel">
        <div class="app-form">
          <div class="page-subtitle">
            {{ $t('application_detail_basic_info') }}
          </div>

          <div class="application-detail-base">
            <ul>
              <!-- 名称 -->
              <li>
                <label>{{ $t('application_detail_affiliation_name') }}:</label>
                <p>
                  {{ appInfo.bindUserName }}
                </p>
              </li>

              <li>
                <label>{{ $t('application_detail_status') }}:</label>
                <p><application-status :status="appInfo.status" /></p>
              </li>
              <li>
                <label>{{ $t('application_detail_access_user') }}:</label>
                <p>
                  {{ appInfo.bindUserName }}
                </p>
              </li>
              <li>
                <label>{{ $t('docs_detail_base_updateTime') }}:</label>
                <p>
                  {{ appInfo.createTime | formatDate }}
                </p>
              </li>
              <li>
                <label>{{ $t('application_detail_descrption') }}:</label>
                <p>
                  {{ appInfo.intro }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="panel item">
          <div class="app-form">
            <div class="page-subtitle">{{ $t('application_detail_auth') }}</div>
            <div class="info-panel">
              <div class="info-item">
                <span>appId: </span>
                <p>
                  {{ appInfo.appid }}
                  <a-icon
                    type="copy"
                    data-clipboard-action="copy"
                    title="Copy"
                    style="color:#ccc"
                    :data-clipboard-text="`${appInfo.appid}`"
                    :id="`application_appid_copy`"
                    @click="copyContent(`#application_appid_copy`)"
                  />
                </p>

                <span>appSecret: </span>
                <p>
                  <i v-if="appSecretInfo">{{ appSecretInfo }}</i>
                  <i v-else>*******</i>
                  <a-icon
                    type="copy"
                    data-clipboard-action="copy"
                    title="Copy"
                    style="color:#ccc"
                    :data-clipboard-text="`${appSecretInfo}`"
                    :id="`application_appsecret_copy`"
                    @click="copyContent(`#application_appsecret_copy`)"
                    v-if="appSecretInfo"
                  />
                  <span
                    @click="getAppSecret"
                    v-if="!appSecretInfo && this.AUTH_APPLICATION_GET_SECRECT"
                  >
                    <Icon type="eye2" />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="panel item">
          <div class="app-form">
            <div class="page-subtitle">
              {{ $t('application_detail_bindUser') }}
            </div>
            <div class="info-panel">
              <div class="info-item">
                {{ appInfo.bindUserName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/application';
import ApplicationStatus from '@/views/application/components/Status';
import { copyContent } from '@/libs/utils';
import applicationAuth from '@/views/application/mixins/applicationAuth';

export default {
  mixins: [applicationAuth],
  components: {
    ApplicationStatus,
  },
  data() {
    return {
      copyContent,
      appInfo: {},
      id: null,

      // 密钥
      appSecretInfo: null,
    };
  },
  created() {
    if (this.$route?.params?.id) {
      this.id = this.$route.params.id;
    }
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (!this.id) {
        return;
      }

      return API.AppDetail({ id: this.id })
        .then(res => {
          if (res.code === 0) {
            this.appInfo = res.data;
          }
        })
        .finally(() => {
          // 全部接口返回时，清除loading
          this.$store.commit('setPageLoading', false);
        });
    },

    // 删除
    remove() {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('application_confirm_delete_title'),
        content: h('div', {}, [
          h('p', this.$t('application_confirm_content', { name: this.appInfo.name })),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.AppDel({ id: this.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));
                this.$router.push({ name: 'ApplicationList' });
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 获取密钥
    getAppSecret() {
      if (!this.id) {
        return;
      }

      return API.AppSecret({ id: this.id }).then(res => {
        if (res.code === 0) {
          this.appSecretInfo = res.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.application-detail {
  background: @g-layout-background;
  height: 100%;
}

::v-deep .app-form {
  max-width: 900px;
  width: 100%;

  .ant-form-item {
    margin: 0 0 5px 0;
  }

  .ant-form-item-label {
    label {
      color: #aaa;
    }
  }

  .ant-form-item-children {
    img {
      max-width: 200px;
    }
  }
}

.panel {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 -12px 0 0 @g-layout-background;
}

.page-subtitle {
  align-items: center;
  color: #18181a;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-header {
  .btn-gap {
    margin-left: 12px;
  }

  .danger-btn {
    font-size: 14px;
    line-height: 24px;
    background: #f5222d;
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
    color: #fff;
  }
}

.detail-content {
  display: flex;

  .left {
    flex: 0 0 60%;
    height: 100%;
    margin-right: 16px;
  }

  .right {
    flex: 1;

    .item {
      height: calc(50% - 10px);

      &:last-child {
        margin-top: 20px;
      }
    }
  }

  .app-form {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .info-panel {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 24px;

      .info-item {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #18181a;
        font-size: 14px;
        line-height: 22px;

        span {
          color: #aaa;
          padding-right: 10px;
        }

        p {
          margin: 0;
          text-align: center;
          margin-right: 15px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 5px;

          i {
            font-style: normal;
          }

          svg {
            cursor: pointer;
          }
        }
      }
    }
  }
}

.application-detail-base {
  border-radius: 12px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 24px;

  ul {
    margin: 0;
    padding: 0;
    width: 70%;
    li {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 16px;
      gap: 16px;

      label {
        color: #a0a0a7;
        text-align: right;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        width: 20%;
      }

      p {
        margin: 0;
        padding: 0;
        color: #18181a;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        flex: 1;
        padding-right: 24px;
      }
    }
  }
}
</style>
